import {request} from '@/utils/axiosFun.js'
// import axios from 'axios';
//获取token
// export const getToken = (query) => {
//     return request('get','/api/common/getApiToken/dmsm',query)
// }
//登录
// export const login = (query) => {
//     return request('post','/api/common/login',query)
// }

//登录
export const login = (query) => {
    return request('post','/yunDuanUrl/dmsm-service-cloud/userLogin/login',query)
}
//用户信息
export const getUserInfo = (query) => {
    return request('get','/yunDuanUrl/dmsm-service-cloud/userLogin/getUserInfo',query)
}

//获取用户类型
export const getDictDataByDictType = (query) => {
    return request('get', `/yunDuanUrl/dmsm-service-cloud/dict/getDictDataByDictType?dictType=USER_TYPE`);
}